import { config, setApi } from '@entando/apimanager';
import { ROUTE_DASHBOARD } from './routedir';


const configApiManager = {
  domain: null, // eslint-disable-line
  useMocks: false,
};

export default (store) => {
  config(store, ROUTE_DASHBOARD, ROUTE_DASHBOARD);
  store.dispatch(setApi(configApiManager));
};
